import { NodeType } from '@/enums/node-type.enum';
import type { ToolInput } from '@/api/toolRunData.api';
import type { DesignAppInput } from '@/types/design-app.types';

// Override ?? baked default ?? per-type empty, so the reused leaf components never crash on an
// undefined `value`.
export function initialToolInputValue(descriptor: ToolInput, override?: DesignAppInput): DesignAppInput['value'] {
  const seedValue = override?.value ?? descriptor.defaultValue;
  // Inspect returns a scalar seed; the form and run payload use { seed, isRandom }.
  if (descriptor.seedConfig && (seedValue == null || typeof seedValue !== 'object')) {
    return {
      isRandom: descriptor.seedConfig.isRandom,
      seed: seedValue == null ? descriptor.seedConfig.seed : Number(seedValue),
    } as unknown as DesignAppInput['value'];
  }
  if (override && override.value != null) {
    return override.value;
  }
  if (descriptor.defaultValue != null) {
    return descriptor.defaultValue as DesignAppInput['value'];
  }
  switch (descriptor.type) {
    case NodeType.Prompt:
    case NodeType.PromptV3:
      return { prompt: '' };
    case NodeType.String:
      return { string: '' };
    case NodeType.Import:
      return { file: undefined } as unknown as DesignAppInput['value'];
    case NodeType.MediaIterator:
      return { files: [] };
    case NodeType.ColorPalette:
      return { colors: [{ r: 255, g: 255, b: 255, a: 1 }] };
    case NodeType.MuxV2:
      return descriptor.isIterator ? { options: [''] } : (0 as unknown as DesignAppInput['value']);
    case NodeType.Boolean:
      return false as unknown as DesignAppInput['value'];
    case NodeType.MultiLora:
      return { selectedLora: null, weight: 0.5 } as unknown as DesignAppInput['value'];
    default:
      return descriptor.seedConfig
        ? ({
            isRandom: descriptor.seedConfig.isRandom,
            seed: descriptor.seedConfig.seed,
          } as unknown as DesignAppInput['value'])
        : (undefined as unknown as DesignAppInput['value']);
  }
}
